import { render, staticRenderFns } from "./PayRangePickerField.vue?vue&type=template&id=3bfb88b4&scoped=true"
import script from "./PayRangePickerField.vue?vue&type=script&setup=true&lang=js"
export * from "./PayRangePickerField.vue?vue&type=script&setup=true&lang=js"
import style0 from "./PayRangePickerField.vue?vue&type=style&index=0&id=3bfb88b4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bfb88b4",
  null
  
)

export default component.exports